import styled from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import TitleWidget from '../TitleWidget';

const BigWrapper = styled.div`
  touch-action: none;
  margin-left: ${rem('-15px')};
  margin-right: ${rem('-15px')};
  ${mediaqueries.greaterThan('tablet')`
    margin-left: ${rem('24px')};
    margin-right: ${rem('24px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
   max-width: ${rem('1180px')};
  `};
`;

const StyledTitleWidget = styled(TitleWidget)`
  ${mediaqueries.greaterThan('tablet')`
    line-height: ${rem('30px')};
    padding-left: ${rem('32px')};
  `};
`;

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${rem('30px')};
  width: 100%;
  height: auto;
  background-color: ${props => props.theme.colors.colorOne};
  ${mediaqueries.greaterThan('desktop')`
   position: relative;
   flex-direction: row;
   background-color: transparent;
  `};
`;

const StyleEventTitle = styled.p`
  color: ${props => props.theme.colors.dark};
  display: inline;
  font-size: ${rem('12px')};
  font-weight: normal;
  margin: 0;
  padding: ${rem('10px')} 0 0 ${rem('10px')};
  position: relative;

  :before {
    background-color: ${props => props.theme.colors.dark};
    border-radius: 50%;
    content: '';
    height: ${rem('6px')};
    width: ${rem('6px')};
    position: absolute;
    top: ${rem('10px')};
    left: 0;
  }

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    padding: 0 0 0 10px;
  `};
`;
const StyleEventText = styled.span`
  display: none;

  ${mediaqueries.greaterThan('mobile')`
    display: inline-block;
    padding-left: ${rem('2px')};
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 97%;
    overflow: hidden;
    padding-left: ${rem('10px')};
  `};
`;

const StyledMonthHeader = styled.span`
  color: ${props => {
    if (props.weekend) {
      return props.theme.colors.gray;
    }
    return props.theme.colors.dark;
  }} !important;
`;

const StyledDay = styled.span`
  color: ${props => props.theme.colors.gray};
`;

export {
  StyledTitleWidget,
  StyleEventTitle,
  StyleEventText,
  StyledWrapper,
  StyledMonthHeader,
  StyledDay,
  BigWrapper
};
